module.exports = __webpack_public_path__ + "static/media/team-spirit-re.7e6ac14c.svg";